import { validExitJob } from './txModel';
export function createExitJournal(getIndexedDB = () => globalThis.indexedDB, name = 'pcd.ptt-exit.v1') {
  let opening;
  function open() {
    if (!opening) opening = new Promise((resolve, reject) => {
      if (!getIndexedDB()) return reject(Error('交易儲存不可用，請先恢復儲存權限。'));
      const request = getIndexedDB().open(name, 1);
      request.onupgradeneeded = () => request.result.createObjectStore('journal');
      request.onerror = () => reject(request.error);
      request.onblocked = () => reject(Error('交易儲存被其他頁面阻擋。'));
      request.onsuccess = () => { request.result.onversionchange = () => { request.result.close(); opening = null; }; resolve(request.result); };
    }).catch(error => { opening = null; throw error; });
    return opening;
  }
  // Resolve only on transaction completion: request success is not durable commit.
  async function transact(change) {
    const db = await open();
    return new Promise((resolve, reject) => {
      const tx = db.transaction('journal', 'readwrite'), store = tx.objectStore('journal');
      let value, failure;
      tx.oncomplete = () => failure ? reject(failure) : resolve(value);
      tx.onerror = tx.onabort = () => reject(failure || tx.error || Error('交易儲存未完成。'));
      const active = store.get('active');
      active.onerror = () => tx.abort();
      active.onsuccess = () => {
        try {
          if (active.result && !validExitJob(active.result)) throw Error('交易記錄無法核實，請勿重送。');
          value = change(store, active.result || null);
        } catch (error) { failure = error; tx.abort(); }
      };
    });
  }
  return {
    inspect: () => transact((store, active) => active),
    acquire: job => transact((store, active) => { if (active) throw Error('已有舊版退出交易待處理，請先查詢。'); if (!validExitJob(job) || job.stage !== 'preparing') throw Error('Invalid B1 intent'); store.put(job, 'active'); return job; }),
    update: (id, change) => transact((store, active) => {
      if (!active || active.id !== id) return null;
      if (Object.keys(change).some(key => !['stage', 'hash', 'originalHash', 'nonce', 'replaced', 'requestBlock', 'requestNonce', 'candidateHash'].includes(key)) || (active.originalHash && change.originalHash && active.originalHash !== change.originalHash)) throw Error('Immutable B1 intent');
      const transitions = { preparing: ['preparing', 'wallet-requested'], 'wallet-requested': ['wallet-requested', 'submitted', 'submission-unknown'], 'submission-unknown': ['submission-unknown', 'submitted'], submitted: ['submitted', 'confirmed-unverified'], 'confirmed-unverified': ['confirmed-unverified'] };
      for (const key of ['requestBlock', 'requestNonce']) if (active[key] !== undefined && change[key] !== undefined && active[key] !== change[key]) throw Error('Immutable request context');
      if (change.stage && !transitions[active.stage].includes(change.stage)) throw Error('Invalid B1 transition');
      const next = { ...active, ...change, id: active.id };
      if (!validExitJob(next)) throw Error('Invalid B1 update');
      store.put(next, 'active'); return next;
    }),
    finish: (id, outcome, onlyPrepared = false) => transact((store, active) => {
      if (!active || active.id !== id || (onlyPrepared && active.stage !== 'preparing')) return false;
      store.put({ ...active, outcome, finishedAt: Date.now() }, 'last'); store.delete('active'); return true;
    }),
    async last() { const db = await open(); return new Promise((resolve, reject) => { const tx = db.transaction('journal', 'readonly'); const req = tx.objectStore('journal').get('last'); let value; req.onsuccess = () => { value = req.result; }; tx.oncomplete = () => resolve(value || null); tx.onerror = tx.onabort = () => reject(tx.error); }); },
  };
}
export const exitJournal = createExitJournal();
